import {
  InternalAccount,
  OnboardingMissingFields
} from "@wingspanhq/wingspan-api-sdk";

const requireAdditionalInformationForType = ["Banking", "TaxWithholding"];

function getOnlyRepresentativeTaxIdMissing(
  missingData?: OnboardingMissingFields
) {
  return (
    missingData?.requiredFields?.length === 1 &&
    missingData.requiredFields[0] === "Representative.individualTaxId"
  );
}

function getDocumentsMissing(missingData?: OnboardingMissingFields) {
  return !!missingData?.completeOnboardingToken;
}

export function getRequireAdditionalInformation(
  internalAccount: InternalAccount,
  missingData?: OnboardingMissingFields,
  featureFlags?: {
    bankingAdditionalInfo?: boolean;
  }
) {
  if (!featureFlags?.bankingAdditionalInfo) {
    return false;
  }

  if (!requireAdditionalInformationForType.includes(internalAccount.type)) {
    return false;
  }

  if (internalAccount.status !== "Pending") {
    return false;
  }

  if (getOnlyRepresentativeTaxIdMissing(missingData)) {
    return true;
  }

  if (getDocumentsMissing(missingData)) {
    return true;
  }

  return false;
}
